<div class="d-flex flex-column h-100 top-div" *ngIf="!isLoading">
  <div class="text-row">
    <span class="accello-general-text12"
      >Select at least two and at most three test cases to view the comparison.</span
    >
    <button class="btn-accello-secondary" (click)="compare()" [disabled]="isDisabled">Compare</button>
  </div>

  <div>
    <app-zorro-table
      tableId="tc-unique"
      class="w-100 overflow-auto"
      [columns]="columns"
      [data]="testArray"
      (onRowSelect)="handleRowSelection($event)"
    ></app-zorro-table>
  </div>

  <div class="w-100 table-div" *ngIf="selectedRowsComparison.length > 0">
    <span class="modal-title">Test case comparison</span>
    <div class="p-4 pb-0 comparison-wrapper d-flex flex-column overflow-auto">
      <div class="cards-wrapper d-flex pb-3 w-100">
        <app-comparison-card
          style="margin-right: 15px; width: 50%"
          *ngFor="let item of selectedRowsComparison; let i = index"
          [data]="item"
          [color]="getColor(i)"
        ></app-comparison-card>
      </div>
    </div>
  </div> 
  <div class="footer d-flex justify-content-end mt-3">
    <button class="btn-accello-primary-outlined align-items-center mx-2" (click)="goBack()">Back</button>
  </div>
  <div class="mb-2">
    <!-- <p style="font-size: 19px;">Test Case Comparison</p>
    <p class="cluster-component py-2">Cluster: <strong>[{{ selectedTestId }}]</strong></p> -->
    <div class="test-comp" style="width:auto">
      <div class="outer-container" style="overflow-x: auto;">
          <div class="selected-cards d-flex">
              
              <div *ngFor="let selectedTest of getSelectedItems() ;let i = index">
                  <div class="card">
                      <h5 class="test-id p-2 " style="text-align: center;">Test ID: {{ selectedTest.testId }}</h5>
                      <div class="p-2">
                      <div><strong>Test Case Name</strong></div>
                        <div>{{ selectedTest.testName }}</div><br>
                        
                        <div ><strong> Test Description</strong></div>
                        <div>
                            {{selectedTest.description}}
                        </div><br>
        
                        <div> <strong>Test Step Description</strong></div>
                       
                        
                        <div *ngFor="let step of formatSteps(selectedTest.corStepDesc)">{{ step }}</div>
        
                        <div> <strong>Expected Results</strong> </div>
                       
                        <div>{{ selectedTest.cleanedExpResult }}</div>
                      </div>
                  </div>
              </div>
             
          </div>

      </div>
      
  </div>
  </div>
</div>

<div class="h-100 v-center" *ngIf="isLoading">
  <app-loading [text]="'Loading...'"></app-loading>
</div>